// ...
export default Object.freeze({
  ProcessInstanceFormFieldAttachment: 1,
  ProcessInstanceGeneratedDocument: 2,
  ProcessInstanceVariableAttachment: 3,
  ProcessInstanceCommentAttachment: 4,
  EntityAttachment: 5,
  ProcessInstanceApiCallAttachment: 6,
  ListExportGeneratedFile: 7,
  EntityExportGeneratedFile: 8,
  EntityImportGeneratedErrorFile: 9,
  ProcessInstanceOpenAICallAttachment: 10,
  ProcessInstanceAutomyAIAttachment: 11,
  ProcessInstanceRunCodeAttachment: 12,
  ChatThreadAttachment: 13,
});
